import { Icon } from '@codex-brightworld/icons';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.span`
  cursor: pointer;

  ${Icon} {
    width: 24px;
    height: 24px;
  }
`;

const Label = styled.span`
  vertical-align: middle;
`;

/** Close button with action handler. It can contain label on its right side or left side */
function Close(props) {
  return (
    <Wrapper
      onClick={props.onClose}
      title={props.tooltipText ? props.tooltipText : null}
      className={props.className || props.classes}
      data-qa={props.qa}
    >
      {props.labelText && props.labelPosition === 'left' &&
        <Label>{props.labelText}</Label>}

      {!props.hideCross && <Icon icon="close" />}
      {props.labelText && props.labelPosition === 'right' &&
        <Label>{props.labelText}</Label>}
    </Wrapper>
  );
}

Close.propTypes = {
  /**
   * @deprecated Use className instead
   */
  classes: PropTypes.string,
  className: PropTypes.string,
  /** Text of the the label */
  labelText: PropTypes.string,
  /** function to be invoked when user clicks on a Close */
  onClose: PropTypes.func,
  labelPosition: PropTypes.oneOf(['left', 'right']),
  /** if close button Close has cross */
  hideCross: PropTypes.bool,
  tooltipText: PropTypes.string,
  qa: PropTypes.string
};

Close.defaultProps = {
  classes: '',
  className: undefined,
  labelText: '',
  labelPosition: 'left',
  onClose: () => {},
  hideCross: false,
  tooltipText: undefined,
  qa: undefined
};

export default Close;
